'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRouter = require('react-router');
var _isNil = require('lodash/isNil');var _isNil2 = _interopRequireDefault(_isNil);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _formatCurrency = require('../../../utils/formatCurrency');var _formatCurrency2 = _interopRequireDefault(_formatCurrency);
var _getCompanyLogoUrl = require('../../../utils/getCompanyLogoUrl');var _getCompanyLogoUrl2 = _interopRequireDefault(_getCompanyLogoUrl);
var _getUserLogoUrl = require('../../../utils/getUserLogoUrl');var _getUserLogoUrl2 = _interopRequireDefault(_getUserLogoUrl);
var _constructLink = require('../../../helpers/constructLink');

var _Contacts = require('./Contacts');var _Contacts2 = _interopRequireDefault(_Contacts);

var _BasicInformation = require('./BasicInformation.scss');var styles = _interopRequireWildcard(_BasicInformation);

var _MobileContacts = require('../../MobileContacts/MobileContacts.scss');var contactsStyles = _interopRequireWildcard(_MobileContacts);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var nisSign = '₪';

var BasicInformation = function BasicInformation(_ref)




















{var price = _ref.price,isRtl = _ref.isRtl,isNative = _ref.isNative,searchOption = _ref.searchOption,translate = _ref.translate,currency = _ref.currency,pricePerSqMeter = _ref.pricePerSqMeter,propertyType = _ref.propertyType,searchOptionType = _ref.searchOptionType,contactsData = _ref.contactsData,isForeign = _ref.isForeign,isMobile = _ref.isMobile,_ref$localisedAddress = _ref.localisedAddress,street_name = _ref$localisedAddress.street_name,house_number = _ref$localisedAddress.house_number,neighborhood = _ref$localisedAddress.neighborhood,city_name = _ref$localisedAddress.city_name,country_name = _ref$localisedAddress.country_name,_ref$additionalInfo = _ref.additionalInfo,floor = _ref$additionalInfo.floor,parkingSpots = _ref$additionalInfo.parkingSpots,area = _ref$additionalInfo.area,rooms = _ref$additionalInfo.rooms,isModalOpen = _ref.isModalOpen,openMobileContactsModal = _ref.openMobileContactsModal,closeMobileContactsModal = _ref.closeMobileContactsModal,isContactBlockVisible = _ref.isContactBlockVisible,stickyContainerRef = _ref.stickyContainerRef,contactButtonRef = _ref.contactButtonRef;
  var currencySymbol = currency ? (0, _formatCurrency2.default)(currency) : nisSign;
  var formatPrice = function formatPrice() {
    var currencySign = price ? currencySymbol : '';
    if (searchOption === 'forShortRent') {
      return isRtl ?
      _react2.default.createElement('span', null, price + ' ' + currencySign + '/' + translate('day')) :
      _react2.default.createElement('span', null, translate('day') + '/' + currencySign + ' ' + price);
    }
    return isRtl ?
    _react2.default.createElement('span', null, price, '\xA0', currencySign) :
    _react2.default.createElement('span', null, currencySign, '\xA0', price);
  };

  var renderCompanyLink = function renderCompanyLink(content, agencyId, isCompanyActive, locale) {var _cx;return (
      _react2.default.createElement(_reactRouter.Link, {
          to: isCompanyActive && (0, _constructLink.constructCompanyLink)(locale, agencyId),
          className: (0, _classnames2.default)((_cx = {}, _cx[
          styles.disabledAgencyLink] = !isCompanyActive, _cx),
          styles.textAlignment) },


        content));};



  var renderLogo = function renderLogo(logoLink, agencyId, isCompanyActive, locale) {
    var logo =
    _react2.default.createElement('div', { className: contactsStyles.realEstateIcon },
      _react2.default.createElement('img', { src: logoLink, alt: '' }));



    return renderCompanyLink(logo, agencyId, isCompanyActive, locale);
  };

  var renderContactsFields = function renderContactsFields(
  contacts,
  agencyId,
  isCompanyActive,
  locale)
  {
    if (!contacts) return null;var


    name =

    contacts.name,userImage = contacts.realtor_image;

    var userImageUrl = (0, _getUserLogoUrl2.default)(userImage);var _contactsData$realEst =

    contactsData.realEstateData,isRealtorProperty = _contactsData$realEst.isAgent,companyLogo = _contactsData$realEst.logo,companyName = _contactsData$realEst.companyName;

    var modifiedCompanyLogoUrl = (0, _getCompanyLogoUrl2.default)(companyLogo);

    return (
      _react2.default.createElement('div', { className: contactsStyles.wrapper },
        isRealtorProperty ?
        _react2.default.createElement('div', { className: contactsStyles.realEstateBlock },
          modifiedCompanyLogoUrl &&
          renderLogo(
          modifiedCompanyLogoUrl,
          agencyId,
          isCompanyActive,
          locale),

          _react2.default.createElement('div', { className: contactsStyles.contactBlock },
            !!companyName &&
            _react2.default.createElement('div', { className: contactsStyles.contactRow },
              isCompanyActive ?
              renderCompanyLink(
              companyName,
              agencyId,
              isCompanyActive,
              locale) :


              _react2.default.createElement('span', {
                  className: (0, _classnames2.default)(
                  contactsStyles.contactName,
                  contactsStyles.userName) },


                companyName)),




            _react2.default.createElement('div', { className: contactsStyles.contactRow },
              !contactsData.shouldRemovePropertyRealtorIcon && _react2.default.createElement('span', { className: contactsStyles.textAlignment }, contactsData.translate('editOwner', 'realtor'))))) :




        _react2.default.createElement('div', { className: contactsStyles.realEstateBlock },
          _react2.default.createElement('div', { className: contactsStyles.realEstateIcon },
            _react2.default.createElement('img', {
              src: userImageUrl,
              alt: '' })),


          _react2.default.createElement('div', { className: contactsStyles.contactBlock },
            name &&
            _react2.default.createElement('div', { className: contactsStyles.contactRow },
              _react2.default.createElement('span', { className: (0, _classnames2.default)(contactsStyles.contactName, contactsStyles.userName) }, name)),


            _react2.default.createElement('div', { className: contactsStyles.contactRow },
              _react2.default.createElement('span', { className: contactsStyles.textAlignment }, contactsData.translate('propertyDetails', 'contacts', 'propertyOwner')))))));






  };

  return (
    _react2.default.createElement('div', { className: styles.wrapper },
      _react2.default.createElement('div', { ref: stickyContainerRef, className: styles.basicInformationWrapper, id: 'stickySection' },
        _react2.default.createElement('div', { className: styles.basicInformationLeftWrapper },
          _react2.default.createElement('div', { className: styles.priceWrapper },
            _react2.default.createElement('div', { className: styles.propertyType },
              propertyType, ' ', searchOptionType),

            _react2.default.createElement('div', { className: styles.priceLine },
              formatPrice(),
              !!pricePerSqMeter && _react2.default.createElement('span', { className: styles.pricePerSqM },
                pricePerSqMeter, '\xA0',

                currencySymbol,
                translate('perSqMeter')))),




          _react2.default.createElement('div', { className: styles.propertyInformation },
            !(0, _isNil2.default)(rooms) &&
            _react2.default.createElement('div', null,
              _react2.default.createElement('p', { className: styles.count }, rooms),
              _react2.default.createElement('p', null, translate('rooms'))),


            !(0, _isNil2.default)(floor) &&
            _react2.default.createElement('div', null,
              _react2.default.createElement('p', { className: styles.count }, floor),
              _react2.default.createElement('p', null, translate('floor'))),


            _react2.default.createElement('div', null,
              _react2.default.createElement('p', { className: styles.count }, area),
              _react2.default.createElement('p', null, translate('size'))),

            _react2.default.createElement('div', null,
              _react2.default.createElement('p', { className: styles.count }, parkingSpots),
              _react2.default.createElement('p', null, translate('parking'))))),



        isMobile &&
        _react2.default.createElement('div', { className: styles.addressWrapper },
          _react2.default.createElement('div', { className: styles.addressLine },
            street_name &&
            _react2.default.createElement('p', { className: styles.streetName },
              street_name, '\xA0', house_number,
              (!neighborhood || neighborhood === city_name) && ',', '\xA0'),



            _react2.default.createElement('div', null,
              neighborhood &&
              neighborhood !== city_name &&
              _react2.default.createElement('div', null,
                neighborhood, '\xA0'),


              city_name, isForeign && ', ' + country_name))),




        isMobile &&
        _react2.default.createElement('div', { id: 'contactBlock', className: (0, _classnames2.default)(contactsStyles.contacts, contactsStyles.propertyContacts) },
          renderContactsFields(
          contactsData.contacts.primary,
          contactsData.realEstateData.agencyId,
          contactsData.isCompanyActive,
          contactsData.locale),

          _react2.default.createElement('button', { ref: contactButtonRef, type: 'button', className: (0, _classnames2.default)('btn btn-primary', contactsStyles.propertyContactsBtn), onClick: openMobileContactsModal },
            translate('contacts', 'agentTitle'))),




        _react2.default.createElement(_Contacts2.default, _extends({},
        contactsData, {
          isNative: isNative,
          isMobile: isMobile,
          searchOption: searchOption,
          isModalOpen: isModalOpen,
          openMobileContactsModal: openMobileContactsModal,
          closeMobileContactsModal: closeMobileContactsModal,
          isContactBlockVisible: isContactBlockVisible })))));




};

BasicInformation.propTypes = {
  price: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  isForeign: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  searchOption: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  currency: _propTypes2.default.string,
  pricePerSqMeter: _propTypes2.default.string,
  propertyType: _propTypes2.default.string,
  searchOptionType: _propTypes2.default.func,
  additionalInfo: _propTypes2.default.object,
  contactsData: _propTypes2.default.object,
  localisedAddress: _propTypes2.default.object,
  openMobileContactsModal: _propTypes2.default.func,
  closeMobileContactsModal: _propTypes2.default.func,
  isModalOpen: _propTypes2.default.bool,
  isContactBlockVisible: _propTypes2.default.bool,
  stickyContainerRef: _propTypes2.default.func,
  contactButtonRef: _propTypes2.default.func };exports.default =


BasicInformation;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/BasicInformation/BasicInformation.js
// module id = 2828
// module chunks = 0